module.exports = __webpack_public_path__ + "img/school9.024e8c67.png";